/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface ISinglePageFormScope extends IBaseFormScope {
        model: SinglePageFormModel;
    }

    export class SinglePageForm extends BaseForm {
        public templateUrl = './app/views/directives/inputForm/singlePageForm.html';
        public controller = [
            '$scope', 'angularLoadService', 'formSectionService', 'ModalService', '$http',
            'dataSourceService', 'formService', 'formDataService', 'growl', 'formCodeFunctionService',
            'customDivService','manageProcessDataConfigurationService', 'apiActionService',
            'securityMatrixService','deleteService', SinglePageFormController
        ];
    }


    export class SinglePageFormModel extends BaseOnePageFormModel {
        public setupImplementedForm() {
            if (this.internalSetupForm()) {
                this.save();
            } else {
                this.loadStepJavascript();
            }
        }
    }

    export class SinglePageFormController extends BaseFormController {
        constructor(
            scope: ISinglePageFormScope,
            angularLoader: services.AngularLoadService,
            formSectionService: services.FormSectionService,
            modalService: any,
            httpService: angular.IHttpService,
            dataSourceService: services.DataSourceService,
            formService: services.FormService,
            formDataService: services.FormDataService,
            growl: angular.growl.IGrowlService,
            formCodeFunctionService: services.FormCodeFunctionService,
            customDivService: services.CustomDivService,
            manageProcessDataConfigurationService: services.ManageProcessDataConfigurationService,
            apiActionService: services.ApiActionService,securityMatrixService:services.SecurityMatrixService,
            deleteService:services.DeleteService) {

            scope.model = new SinglePageFormModel(angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, scope.process, formDataService,
                growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiActionService,securityMatrixService,deleteService,scope);
            super(scope);
        }
    }
}
warsApp.registerDirective('SinglePageForm', []);